import LoginPrompt from '@/components/LoginPrompt'
import { TabPane, Tabs } from '@/components/Tabs'
import { ElCheckbox } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { useDoubleContractAssetsAccountStore, useDoubleContractOrderListStore, useResponsive } from 'store'
import { LazyLoadingComponent } from 'ui-components'
import '../styles/order-list-wrap.scss'
import { LimitOrders } from './LimitOrders'
import { OpenPosition } from './OpenPosition'
import { StrategyOrders } from './StrategyOrders'

enum OrderListTab {
  Position = 'position',
  CurrentOrder = 'currentOrder',
  Strategy = 'strategy',
}

type OrderListProps = {
  fromAssetAccount?: boolean
}

export const OrderList = defineComponent<OrderListProps>({
  props: {
    fromAssetAccount: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { t } = useI18n()
    const activeTab = ref(OrderListTab.Position)
    const contractAssetsAccountStore = useDoubleContractAssetsAccountStore()
    const orderListStore = useDoubleContractOrderListStore()
    const responsive = useResponsive()

    onMounted(() => {
      orderListStore.getLimitOrders()
      if (!props.fromAssetAccount) {
        orderListStore.getIcebergStrategyOrders()
      }
    })

    watch(
      () => contractAssetsAccountStore.doubleContractAssetsAccount?.openFutures,
      (openFutures) => {
        if (openFutures !== 1) return
        orderListStore.getLimitOrders()
        if (!props.fromAssetAccount) {
          orderListStore.getIcebergStrategyOrders()
        }
      },
    )

    onBeforeUnmount(() => {
      orderListStore.stopTimeoutLimitOrders()
      if (!props.fromAssetAccount) {
        orderListStore.stopTimeoutIcebergStrategyOrders()
      }
    })

    return () => (
      <div class="order-list-wrap order-list-container">
        <Tabs
          v-model={activeTab.value}
          tabHeight={42}
          lineWidth={16}
          tabNavHeight={'auto'}
          showDivider={responsive.isMobile}
          headerRight={() => {
            if (activeTab.value === OrderListTab.Position) {
              return <ElCheckbox v-model={contractAssetsAccountStore.hideOtherOrder}>{t('隐藏其他币种')}</ElCheckbox>
            }
            if (activeTab.value === OrderListTab.CurrentOrder) {
              return <ElCheckbox v-model={orderListStore.currentHideOtherOrder}>{t('隐藏其他币种')}</ElCheckbox>
            }
            if (activeTab.value === OrderListTab.Strategy && !props.fromAssetAccount) {
              return <ElCheckbox v-model={orderListStore.strategyHideOtherOrder}>{t('隐藏其他币种')}</ElCheckbox>
            }
            return null
          }}
        >
          <TabPane name={OrderListTab.Position} label={t('持仓') + `(${contractAssetsAccountStore.positions.length})`}>
            <LazyLoadingComponent>
              <LoginPrompt>{{ default: () => <OpenPosition fromAssetAccount={props.fromAssetAccount} /> }}</LoginPrompt>
            </LazyLoadingComponent>
          </TabPane>
          <TabPane name={OrderListTab.CurrentOrder} label={t('当前委托') + `(${orderListStore.limitOrders.length})`}>
            <LoginPrompt>{{ default: () => <LimitOrders /> }}</LoginPrompt>
          </TabPane>
          {!props.fromAssetAccount && (
            <TabPane name={OrderListTab.Strategy} label={t('策略') + `(${orderListStore.icebergStrategyOrders.length})`}>
              <LoginPrompt>{{ default: () => <StrategyOrders /> }}</LoginPrompt>
            </TabPane>
          )}
        </Tabs>
      </div>
    )
  },
})
